import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgDiscoverFill = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.75 10.5a5.25 5.25 0 1 1-10.499 0 5.25 5.25 0 0 1 10.499 0m5.78 11.03a.747.747 0 0 1-1.06 0l-4.694-4.693a8.25 8.25 0 1 1 1.061-1.06l4.694 4.692a.747.747 0 0 1 0 1.062M10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.76 6.76 0 0 0 6.75 6.75"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDiscoverFill);
export default ForwardRef;
